import {
	Typography,
	Grid,
	Card,
	CardMedia,
	CardContent,
	CardActions,
	Button,
} from '@material-ui/core';

import useStyles from './styles';

const Products = () => {
	const classes = useStyles();

	return (
		<>
			<Grid item xs={12} sm={6} md={4}>
				<Card elevation={7} className={classes.card}>
					<CardMedia
						className={classes.cardMedia}
						image="https://www.haceloconhuevos.com/wp-content/uploads/2019/08/QUEQUE-DE-BANANO-CON-NUECES-848x477.jpg"
					/>
					<CardContent className={classes.cardContent}>
						<Typography
							gutterBottom
							variant="h4"
							className={classes.cardTitlePrice}
						>
							Pan de banano
						</Typography>
						<Typography align="justify" gutterBottom variant="subtitle1">
							El sabroso pan de banano de Marv's Bakery que con su toque
							caribeño que deja loco a cualquiera.
						</Typography>
						<CardActions className={classes.priceButtonContainer}>
							<Typography variant="h6">Precio: ₡3500</Typography>
							<a
								style={{ textDecoration: 'none' }}
								href="https://wa.link/glbj57"
							>
								<Button
									className={classes.cardButton}
									variant="contained"
									color="primary"
								>
									Hacer pedido
								</Button>
							</a>
						</CardActions>
					</CardContent>
				</Card>
			</Grid>
			<Grid item xs={12} sm={6} md={4}>
				<Card elevation={7} className={classes.card}>
					<CardMedia
						className={classes.cardMedia}
						image="https://cocina.guru/wp-content/uploads/2019/10/pastel-de-calabaza.jpg"
					/>
					<CardContent className={classes.cardContent}>
						<Typography
							gutterBottom
							variant="h4"
							className={classes.cardTitlePrice}
						>
							Pan de ayote
						</Typography>
						<Typography align="justify" gutterBottom variant="subtitle1">
							Este pan de ayote está hecho con los mejores ingredientes y es una
							de las resposterías más ricas que ofrece esta tienda.
						</Typography>
						<CardActions className={classes.priceButtonContainer}>
							<Typography variant="h6">Precio: ₡3500</Typography>
							<a
								style={{ textDecoration: 'none' }}
								href="https://wa.link/glbj57"
							>
								<Button
									className={classes.cardButton}
									variant="contained"
									color="primary"
								>
									Hacer pedido
								</Button>
							</a>
						</CardActions>
					</CardContent>
				</Card>
			</Grid>
			<Grid item xs={12} sm={6} md={4}>
				<Card elevation={7} className={classes.card}>
					<CardMedia
						className={classes.cardMedia}
						image="https://2.bp.blogspot.com/-mXzhqQZimsM/Wr7IBROsC-I/AAAAAAAAASE/o5OMCMYiwVYwuUhtrVrEHUX6O8QrohCiwCLcBGAs/s1600/Pan_Bon.jpg"
					/>
					<CardContent className={classes.cardContent}>
						<Typography
							gutterBottom
							variant="h4"
							className={classes.cardTitlePrice}
						>
							Pan bon
						</Typography>
						<Typography align="justify" gutterBottom variant="subtitle1">
							El pan bon es un pan tradicional caribeño hecho de una variedad de
							ingredientes exóticos, en los cuales resulta su delicioso sabor.
						</Typography>
						<CardActions className={classes.priceButtonContainer}>
							<Typography variant="h6">Precio: ₡4000</Typography>
							<a
								style={{ textDecoration: 'none' }}
								href="https://wa.link/glbj57"
							>
								<Button
									className={classes.cardButton}
									variant="contained"
									color="primary"
								>
									Hacer pedido
								</Button>
							</a>
						</CardActions>
					</CardContent>
				</Card>
			</Grid>
			<Grid item xs={12} sm={6} md={4}>
				<Card elevation={7} className={classes.card}>
					<CardMedia
						className={classes.cardMedia}
						image="https://thelocalpalate.com/wp-content/uploads/2021/01/Johnnycakes-thumbnail.jpg"
					/>
					<CardContent className={classes.cardContent}>
						<Typography
							gutterBottom
							variant="h4"
							className={classes.cardTitlePrice}
						>
							Johnnycake 6 Uds.
						</Typography>
						<Typography align="justify" gutterBottom variant="subtitle1">
							Los johnnycake son unos snacks esponjosos con un sabor que permite
							crear combinaciones de sabores salados y dulces.
						</Typography>
						<CardActions className={classes.priceButtonContainer}>
							<Typography variant="h6">Precio: $2500</Typography>
							<a
								style={{ textDecoration: 'none' }}
								href="https://wa.link/glbj57"
							>
								<Button
									className={classes.cardButton}
									variant="contained"
									color="primary"
								>
									Hacer pedido
								</Button>
							</a>
						</CardActions>
					</CardContent>
				</Card>
			</Grid>
			<Grid item xs={12} sm={6} md={4}>
				<Card elevation={7} className={classes.card}>
					<CardMedia
						className={classes.cardMedia}
						image="https://www.lavanguardia.com/files/og_thumbnail/uploads/2019/02/15/5e998008bb516.jpeg"
					/>
					<CardContent className={classes.cardContent}>
						<Typography
							gutterBottom
							variant="h4"
							className={classes.cardTitlePrice}
						>
							Rollo de canela
						</Typography>
						<Typography align="justify" gutterBottom variant="subtitle1">
							Los rollos de canela son de los postres más deliciosos que ha
							creado el ser humano, por supuesto, no podía quedarse atrás.
						</Typography>
						<CardActions className={classes.priceButtonContainer}>
							<Typography variant="h6">Precio: ₡4500</Typography>
							<a
								style={{ textDecoration: 'none' }}
								href="https://wa.link/glbj57"
							>
								<Button
									className={classes.cardButton}
									variant="contained"
									color="primary"
								>
									Hacer pedido
								</Button>
							</a>
						</CardActions>
					</CardContent>
				</Card>
			</Grid>
			<Grid item xs={12} sm={6} md={4}>
				<Card elevation={7} className={classes.card}>
					<CardMedia
						className={classes.cardMedia}
						image="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTcAuwXSioU2C_ve3NHLSDmFBseUkNcmtnNiA&usqp=CAU"
					/>
					<CardContent className={classes.cardContent}>
						<Typography
							gutterBottom
							variant="h4"
							className={classes.cardTitlePrice}
						>
							Budín
						</Typography>
						<Typography align="justify" gutterBottom variant="subtitle1">
							Nada más tradicional que un buen budín con café o aguadulce, en
							Marv's Bakery el budín no es la excepción.
						</Typography>
						<CardActions className={classes.priceButtonContainer}>
							<Typography variant="h6">Precio: ₡3000</Typography>
							<a
								style={{ textDecoration: 'none' }}
								href="https://wa.link/glbj57"
							>
								<Button
									className={classes.cardButton}
									variant="contained"
									color="primary"
								>
									Hacer pedido
								</Button>
							</a>
						</CardActions>
					</CardContent>
				</Card>
			</Grid>
		</>
	);
};

export default Products;
